<template>
    <b-row>
      <b-col md="6">
        <b-card title="Pedidos" >
        <b-table
            :striped="true"
            :bordered="true"
            :hover="true"
            :responsive="true"
            table-variant="secondary"
            :fields="fields"
            :items="$store.state.PTC_Dashboard.RetornaQTDPedidosDashPTC.qtdPedidos"
            show-empty
            empty-text="Nenhum registro encontrado"
        >
          <template #cell(pedidoSituacao)="data">
            {{ data.item.pedidoSituacao ? data.item.pedidoSituacao : 'Sem classificação' }}
          </template>

          <template #cell(Qtde)="data">
            {{ data.item.Qtde ? data.item.Qtde : '-' }}
          </template>

          <template #cell(ValorTotal)="data">
            {{ data.item.ValorTotal ? data.item.ValorTotal : '-' }}
          </template>

          <template #cell(acoes)="data">
            <b-button
              variant="primary"
              size="sm"
              :to="{
                name: 'pedidos',
                params: {
                  dataDash: dataDash,
                  situacaoPedido: data.item.pedidoSituacao
                }
              }"
            >
              Detalhes
            </b-button>
          </template>
        </b-table>
      </b-card>
      </b-col>
      <b-col md="6">
        <b-card title="Pedidos">
          <apex-chart-ratio ref="atualizarGrafico" :option-data="option" class="mt-4" />
        </b-card>
      </b-col>
    </b-row>
</template>

<script>
import ApexChartRatio from '@/views/app/PTC/DashBoard/analytics/apexChart/apexChartRatio.vue';
import { BCard, BCol, BRow } from 'bootstrap-vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    ApexChartRatio,
    BCard,
    BCol,
    BRow,
  },
  data() {
    return {
      fields: [
        { key: 'pedidoSituacao', label: 'Situação', sortable: true },
        { key: 'Qtde', label: 'Qtde. Pedidos', sortable: true },
        { key: 'ValorTotal', label: 'Valor Total', sortable: true },
        { key: 'acoes', label: 'Ações', sortable: true },
      ],
      option: {
        labels: [],
        series: [],
      },
      dataDash: null,
    };
  },
  methods: {
    async atualizarDados(data) {
      this.option.labels = [...this.getLabelsPedido];
      this.option.series = [...this.getSeriesPedido];
      this.$refs.atualizarGrafico.atualizarGraficoPedido();
      this.dataDash = data;
    },
  },
  computed: {
    ...mapGetters({
      getSeriesPedido: 'PTC_Dashboard/getSeriesPedido',
      getLabelsPedido: 'PTC_Dashboard/getLabelsPedido',
    }),
  },
};

</script>
<style scoped lang="scss">

</style>
